var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardLabelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0077 14.9943C10.3499 14.9943 9.00586 16.3383 9.00586 17.9961V23.9999H15.0096V17.9961C15.0096 16.3383 13.6656 14.9943 12.0077 14.9943Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0106 17.9963V24H21.0131C22.671 24 24.015 22.656 24.015 20.9981V11.8715C24.0152 11.3516 23.8132 10.8521 23.4516 10.4786L14.9483 1.28584C13.448 -0.337513 10.9157 -0.437185 9.29233 1.06319C9.21522 1.13448 9.14093 1.20873 9.06968 1.28584L0.581378 10.4756C0.208865 10.8506 -0.000140642 11.3579 7.1005e-08 11.8865V20.9981C7.1005e-08 22.656 1.34399 24 3.00187 24H7.00434V17.9963C7.02306 15.2677 9.22601 13.0396 11.8858 12.9754C14.6346 12.9091 16.9896 15.1752 17.0106 17.9963Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0077 14.9943C10.3499 14.9943 9.00586 16.3383 9.00586 17.9961V23.9999H15.0096V17.9961C15.0096 16.3383 13.6656 14.9943 12.0077 14.9943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLabelIcon);
export default __webpack_public_path__ + "static/media/dashboardLabelIcon.efad4f09bf06e454ddf7f7798799afcc.svg";
export { ForwardRef as ReactComponent };